export function useCDN() {
    const config = useRuntimeConfig()
    const cdn = `${config.public.cdn}`

    return { cdn }
}
